<template>
  <div class="order-status-multi-select" ref="container">
    <div class="form-group">
      <button
        type="button"
        class="form-control multi-select-trigger"
        @click="toggleOpen"
        :aria-expanded="isOpen"
      >
        <span class="trigger-label">{{ summaryLabel }}</span>
        <i class="fa fa-chevron-down"></i>
      </button>

      <div v-if="isOpen" class="multi-select-panel">
        <label
          v-for="option in options"
          :key="option.value"
          class="multi-select-option"
        >
          <input
            type="checkbox"
            :value="option.value"
            :checked="isChecked(option.value)"
            @change="toggleOption(option.value)"
          />
          <span>{{ option.text }}</span>
        </label>
        <!-- TODO: Archived option (IsArchived DB field not yet implemented) -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OrderStatusMultiSelect',
  props: {
    options: {
      type: Array,
      default: () => []
    },
    value: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      isOpen: false
    };
  },
  computed: {
    summaryLabel() {
      if (!this.value || this.value.length === 0) return 'Order Status';
      const names = this.value.map(v => {
        const opt = this.options.find(o => o.value === v);
        return opt ? opt.text : null;
      }).filter(Boolean);
      if (names.length === 0) return 'Order Status';
      if (names.length === 1) return names[0];
      return `${names.length} selected`;
    }
  },
  methods: {
    isChecked(val) {
      return this.value && this.value.includes(val);
    },
    toggleOption(val) {
      const current = this.value ? [...this.value] : [];
      const idx = current.indexOf(val);
      if (idx === -1) {
        current.push(val);
      } else {
        current.splice(idx, 1);
      }
      this.$emit('input', current);
    },
    toggleOpen() {
      this.isOpen = !this.isOpen;
    },
    handleOutsideClick(e) {
      if (this.$refs.container && !this.$refs.container.contains(e.target)) {
        this.isOpen = false;
      }
    }
  },
  mounted() {
    document.addEventListener('click', this.handleOutsideClick);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleOutsideClick);
  }
};
</script>

<style lang="scss" scoped>
.order-status-multi-select {
  .form-group {
    position: relative;
    margin-bottom: 0;
  }

  .multi-select-trigger {
    display: flex;
    align-items: center;
    justify-content: space-between;
    text-align: left;
    cursor: pointer;
    background: #fff;
    border: 1px solid #ddd;
    border-radius: 3px;
    height: 32px;
    font-size: 0.875rem;
    padding: 4px 8px;
    min-width: 160px;
    max-width: 240px;
    white-space: nowrap;
    overflow: hidden;

    .trigger-label {
      overflow: hidden;
      text-overflow: ellipsis;
      flex: 1;
      color: #495057;
    }

    i.fa {
      margin-left: 6px;
      color: #666;
      flex-shrink: 0;
    }

    &:focus {
      outline: none;
      border-color: #80bdff;
      box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
    }
  }

  .multi-select-panel {
    position: absolute;
    top: 100%;
    left: 0;
    z-index: 1000;
    background: #fff;
    border: 1px solid #ddd;
    border-radius: 3px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    min-width: 180px;
    padding: 4px 0;
  }

  .multi-select-option {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 6px 12px;
    cursor: pointer;
    font-size: 0.875rem;
    font-weight: normal;
    margin: 0;
    white-space: nowrap;

    &:hover {
      background-color: #f8f9fa;
    }

    input[type="checkbox"] {
      cursor: pointer;
      margin: 0;
    }
  }
}
</style>
